export default function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center px-8 py-16 text-zinc-500">
      {Icon && (
        <div className="w-12 h-12 rounded-2xl border border-white/[0.08] flex items-center justify-center mb-4">
          <Icon size={20} className="text-zinc-600" />
        </div>
      )}
      <div className="font-display text-sm text-zinc-300 mb-1">{title}</div>
      {description && (
        <div className="text-xs text-zinc-500 max-w-md leading-relaxed">
          {description}
        </div>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
